import { z } from 'zod';
import { uuid } from './common.js';

// One row in the cluster switcher. developer_* are nullable so a cluster
// without a developer (shouldn't happen post-backfill) still renders.
export const clusterSummary = z.object({
  id: uuid,
  name: z.string(),
  developer_id: uuid.nullable(),
  developer_name: z.string().nullable(),
});
export type ClusterSummary = z.infer<typeof clusterSummary>;

// GET /admin/my-clusters
export const myClustersResponse = z.object({
  clusters: z.array(clusterSummary),
  active_cluster_id: uuid,
});
export type MyClustersResponse = z.infer<typeof myClustersResponse>;

// POST /admin/switch-cluster
export const switchClusterRequest = z.object({
  cluster_id: uuid,
});
export type SwitchClusterRequest = z.infer<typeof switchClusterRequest>;

// GET /cluster/config — resident-app config for the caller's active cluster.
export const clusterConfigResponse = z.object({
  name: z.string(),
  hero_image_url: z.string().nullable(),
});
export type ClusterConfigResponse = z.infer<typeof clusterConfigResponse>;

// PUT /cluster/branding — set/clear the resident-app hero image.
// The admin caps uploads at 5 MB; this max is a backstop for the base64
// data-URL fallback path (5 MB → ~7 M base64 chars + a data: prefix).
export const updateClusterBrandingRequest = z.object({
  hero_image_url: z.string().max(7_200_000).nullable(),
});
export type UpdateClusterBrandingRequest = z.infer<typeof updateClusterBrandingRequest>;
